import { useAuth } from "@utils/firebaseAuth/auth";

const useBackendQueryEnabled = () => {
  const { firebaseUser } = useAuth();

  return !!firebaseUser;
};

export default useBackendQueryEnabled;
